import React from 'react'

import { format, parseISO } from 'date-fns'

import { makeStyles, Box, List } from '@material-ui/core'

import CustomDivider from './CustomDivider'
import CustomListItem from './CustomListItem'
import CustomListItemText from './CustomListItemText'

import { getFullName } from '../../helpers'
import { Customer } from '../../model/customer.model'
import SegmentSign from '../SegmentSign/SegmentSign'

const useStyles = makeStyles((theme) => ({
  main: {
    width: '100%',
    padding: theme.spacing(0, 10, 0, 12),
  },
  listItemText: {
    margin: theme.spacing(0),
  },
}))

interface ClientDataProps {
  customer: Customer
}

const ClientData: React.FC<ClientDataProps> = ({ customer }) => {
  const classes = useStyles()

  const { personal } = customer
  const contactPhone = customer.business ? customer.business.otherPhone : personal?.otherPhone
  return (
    <Box width="100%" data-hook="client-data">
      <List className={classes.main}>
        <Box pt={3} pb={4}>
          <SegmentSign type={customer.sector} customerId={customer.id} />
        </Box>

        <CustomListItemText
          className={classes.listItemText}
          primary={customer.business ? customer.business.company : getFullName(customer)}
          primaryTypographyProps={{ variant: 'subtitle2' }}
        />
        <CustomListItemText
          className={classes.listItemText}
          primary={customer.documentValue}
          primaryTypographyProps={{ variant: 'subtitle2' }}
        />

        <CustomListItemText
          className={classes.listItemText}
          primary={`Tlfn contacto: ${contactPhone || '-'}`}
          primaryTypographyProps={{ variant: 'subtitle2' }}
        />

        <Box pt={4} pb={1}>
          <CustomDivider />
        </Box>

        <CustomListItem button disableGutters>
          <CustomListItemText
            primary="Activo desde: "
            primaryTypographyProps={{ variant: 'body2' }}
          />
          {customer.activationDate ? (
            <CustomListItemText
              primary={` ${format(parseISO(customer.activationDate), 'dd/MM/yyyy')}`}
              primaryTypographyProps={{ variant: 'subtitle2' }}
            />
          ) : (
            '-'
          )}
        </CustomListItem>
      </List>
      <Box paddingTop={1}>
        <CustomDivider />
      </Box>
    </Box>
  )
}

export default ClientData
